import React from "react";
import { Row, Col, Card, Badge, Skeleton, Breadcrumb } from "antd"; // Tambahkan Breadcrumb
import { useState, useEffect } from "react";
import { useHttp } from "../../../utils/DataHendler";
import { useParams, useNavigate } from "react-router-dom"; // Tambahkan useNavigate
import { useLocation } from "react-router-dom";
import { formatDate } from "../../../utils/DateTime";

export const DetailCard = () => {
  const location = useLocation();
  const routeFrom = location.state?.routeFrom;
  // Data fetching menggunakan custom hook
  const { getData } = useHttp();
  const { code } = useParams(); // Mendapatkan parameter `code` dari URL
  const [data, setData] = useState(null); // State untuk menyimpan data kartu
  const [loading, setLoading] = useState(true); // State untuk menangani loading
  const navigate = useNavigate(); // Untuk navigasi kembali ke halaman sebelumnya

  // Fungsi untuk mengambil data kartu
  useEffect(() => {
    getCard();
  }, []);

  const getCard = async () => {
    try {
      const response = await getData(`/card/${code}`, {}, true);
      console.log(response.data);
      setData(response.data);
      setLoading(false); // Menghentikan loading setelah data berhasil diambil
    } catch (error) {
      console.error("Error fetching card data:", error);
      setLoading(false); // Menghentikan loading jika terjadi error
    }
  };

  // Loading skeleton untuk tampilan sementara
  if (loading) {
    return (
      <div style={{ padding: "20px" }}>
        <Skeleton active paragraph={{ rows: 4 }} />
      </div>
    );
  }

  // Jika data tidak tersedia
  if (!data) {
    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <p>Data not available</p>
      </div>
    );
  }

  return (
    <div style={{ padding: "20px" }}>
      {/* Breadcrumb */}
      <Breadcrumb style={{ marginBottom: "20px" }}>
        <Breadcrumb.Item>
          <a
            onClick={() => {
              if (routeFrom === "detail-card") {
                navigate(-1); // Kembali ke halaman sebelumnya
              } else {
                navigate("/user/card-list");
              }
            }}
          >
            {routeFrom === "detail-card" ? "Back" : "Card List"}
          </a>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Detail Card</Breadcrumb.Item>
      </Breadcrumb>

      {/* Komponen utama dengan Card */}
      <Card
        title="Detail Card"
        style={{
          width: "100%",
          borderRadius: "8px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* Informasi kode kartu */}
        <div style={{ marginBottom: "15px" }}>
          <strong>Card Code:</strong>{" "}
          <span style={{ color: "#1890ff", fontWeight: "bold" }}>
            {data.code}
          </span>
        </div>

        {/* History Pengguna Card: Visitor List */}
        <div style={{ marginBottom: "30px" }}>
          <strong>Visitor Card History:</strong>
          <div style={{ marginTop: "10px" }}>
            {data.visitor_card_list?.length > 0 ? (
              <Row gutter={[16, 16]} justify="start">
                {data.visitor_card_list.map((visitor, index) => (
                  <Col key={visitor.id} xs={24} sm={12} md={8} lg={6} xl={6}>
                    <Card
                      hoverable
                      onClick={() => {
                        navigate(`/user/detail/${visitor.visitor_code}`, {
                          state: { routeFrom: "detail-card" },
                        });
                      }}
                      style={{
                        border: visitor.returned_at
                          ? "1px solid green"
                          : "1px solid red",
                        borderRadius: "8px",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>
                        <strong>{visitor.visitor_name}</strong>
                        <p style={{ margin: "5px 0" }}>
                          Take Card At:{" "}
                          {visitor.taken_at
                            ? formatDate(visitor.taken_at)
                            : "-"}
                        </p>
                        <p style={{ margin: "5px 0" }}>
                          Return Card At:{" "}
                          {visitor.returned_at ? (
                            formatDate(visitor.returned_at)
                          ) : (
                            <div
                              style={{
                                backgroundColor: "red", // Warna latar belakang merah
                                borderRadius: "5px", // Border radius 5px untuk sudut yang melengkung
                                padding: "1px 5px", // Ruang di dalam div agar teks tidak terlalu rapat
                                animation: "blink 1s infinite", // Efek berkelip-kelip
                                display: "inline-block", // Agar div hanya sebesar kontennya (persegi panjang)
                              }}
                            >
                              <span
                                style={{
                                  color: "white", // Warna teks putih
                                  fontSize: "12px", // Ukuran font 12px
                                }}
                              >
                                not back yet
                              </span>
                            </div>
                          )}
                        </p>
                        <p
                          style={{
                            margin: "5px 0",
                            fontSize: "12px",
                            color: "#888",
                          }}
                        >
                          Created:{" "}
                          {visitor.created_at
                            ? formatDate(visitor.created_at)
                            : "-"}
                        </p>
                      </div>
                    </Card>
                  </Col>
                ))}
              </Row>
            ) : (
              <p style={{ color: "#f5222d", fontStyle: "italic" }}>
                No visitor card history found
              </p>
            )}
          </div>
        </div>

        {/* History Pengguna Card: Institution Visitor List */}
        <div>
          <strong>Institution Visitor Card History:</strong>
          <div style={{ marginTop: "10px" }}>
            {data.institution_visitor_list?.length > 0 ? (
              <Row gutter={[16, 16]} justify="start">
                {data.institution_visitor_list.map((inst, idx) => (
                  <Col key={inst.id} xs={24} sm={12} md={8} lg={6} xl={6}>
                    <Card
                      hoverable
                      onClick={() => {
                        // Navigasi ke detail institution visitor jika ada
                        navigate(`/user/institution/${inst.institution_id}`);
                      }}
                      style={{
                        border: inst.back_card_date
                          ? "1px solid green"
                          : "1px solid red",
                        borderRadius: "8px",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>
                        <strong>{inst.institution_visitor_name}</strong>
                        <p style={{ margin: "5px 0" }}>NIK: {inst.nik}</p>
                        <p style={{ margin: "5px 0" }}>
                          Take Card At:{" "}
                          {inst.regist_date
                            ? formatDate(inst.regist_date)
                            : "-"}
                        </p>
                        <p style={{ margin: "5px 0" }}>
                          Return Card At:{" "}
                          {inst.back_card_date ? (
                            formatDate(inst.back_card_date)
                          ) : (
                            <div
                              style={{
                                backgroundColor: "red", // Warna latar belakang merah
                                borderRadius: "5px", // Border radius 5px untuk sudut yang melengkung
                                padding: "1px 5px", // Ruang di dalam div agar teks tidak terlalu rapat
                                animation: "blink 1s infinite", // Efek berkelip-kelip
                                display: "inline-block", // Agar div hanya sebesar kontennya (persegi panjang)
                              }}
                            >
                              <span
                                style={{
                                  color: "white", // Warna teks putih
                                  fontSize: "12px", // Ukuran font 12px
                                }}
                              >
                                not back yet
                              </span>
                            </div>
                          )}
                        </p>
                        <p
                          style={{
                            margin: "5px 0",
                            fontSize: "12px",
                            color: "#888",
                          }}
                        >
                          Phone: {inst.phone || "-"}
                        </p>
                      </div>
                    </Card>
                  </Col>
                ))}
              </Row>
            ) : (
              <p style={{ color: "#f5222d", fontStyle: "italic" }}>
                No institution visitor card history found
              </p>
            )}
          </div>
        </div>
      </Card>
    </div>
  );
};
